var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-pad-coach-marks"},[_c('ChalkyUiCoachMarkSequencer',{attrs:{"id":"tipPadTutorial","arrow":true,"steps":_vm.steps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }